import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import {
  FlexRowCenter,
  FlexCol,
  FlexRow,
  FlexRowCenterVertical,
} from '../../Defaults/Flexbox/Flexbox';
import { TextP } from '../../Defaults/Text';
import { ButtonWithRequest } from './ButtonWithRequest';

interface Props {
  price: string;
  isSale: number;
  oldPrice: string;
  salePercentage: string;
  avail_id: number;
  addToRequest: any;
  addToCart: any;
}

function ProductPriceCart({
  price,
  isSale,
  oldPrice,
  addToCart,
  addToRequest,
  salePercentage,
  avail_id,
}: Props) {
  return (
    <Wrapper>
      {avail_id === 11 || !avail_id ? (
        <Soon>{`UŽ ČOSKORO`}</Soon>
      ) : (
        <>
          <PriceCol>
            <PriceRow>
              {isSale === 1 && (
                <OldPrice>{`${oldPrice} € (-${salePercentage}%)`}</OldPrice>
              )}
              <Price>{`${price} €`}</Price>
            </PriceRow>
          </PriceCol>
          <ButtonWithRequest
            onButtonClick={addToCart}
            onRequestClick={addToRequest}
            avail_id={avail_id}
          />
        </>
      )}
    </Wrapper>
  );
}

const Wrapper = styled(FlexRowCenter)`
  width: 100%;
  height: ${rem(48)};
  margin-bottom: ${rem(8)};
  justify-content: space-between;
`;

const PriceCol = styled(FlexCol)``;

const PriceRow = styled(FlexRow)`
  display: flex;
  flex-direction: column;
  text-align: left;
  margin-bottom: ${rem(4)};
`;

const Price = styled(TextP)`
  font-family: ${({ theme }) => theme.font.primary};
  font-size: ${rem(24)};
  font-weight: 500;
  line-height: ${rem(22)};
  color: ${({ theme }) => theme.colors.textPrimary};
  margin-right: ${rem(6)};
  white-space: nowrap;
`;

const SecondaryText = styled(TextP)`
  font-family: ${({ theme }) => theme.font.primary};
  font-size: ${rem(16)};
  line-height: ${rem(20)};
  color: ${({ theme }) => theme.colors.placeholder};
`;

const OldPrice = styled(SecondaryText)`
  color: ${({ theme }) => theme.colors.stockCountSold};
  letter-spacing: 0;

  ${({ theme }) => theme.mediab.l1050`
    display: none;
  `}
`;

const Soon = styled(TextP)`
  width: 100%;
  text-align: center;
  font-size: ${rem(24)};
  font-weight: 500;
  color: #cccccc;
`;

export { ProductPriceCart };
